import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g(_vm._b({style:(_vm.smallFont ? 'font-size: 0.75rem' : '')},'span',_vm.labelAttrs,false),on),[_vm._v(" "+_vm._s(_vm.fromNow(_vm.date, _vm.withoutSuffix))+" ")])]}}])},'v-tooltip',_vm.$attrs,false),[_c('span',[_vm._v(" "+_vm._s(_vm.formatTimestamp(_vm.date, (_vm.fmt = 'std')))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }